import get from 'lodash/get';

import { PaymentMethodServiceModule } from 'services/payment/paymentMethod/paymentMethod.service';
import { CreditCardServiceModule } from 'services/payment/stripe/creditCard.service';
import { MyAccountServiceModule } from 'services/data/myAccount.service';
import { AuthTokenServiceModule } from 'services/auth/authToken.service';
import { trackEvent } from 'admin/services/tracking/GtmTracking';

export const UpdatePaymentServiceModule = angular
    .module('app.components.updatePayment.updatePaymentService', [
        PaymentMethodServiceModule,
        CreditCardServiceModule,
        MyAccountServiceModule,
        AuthTokenServiceModule
    ]).service('updatePaymentService', (
        myAccountService,
        creditCardService,
        paymentMethodService,
        $q,
        authTokenService
    ) => {
        function changePaymentMethod(card, billingAddress) {
            const userPromise = myAccountService.getUser();
            const tenantPromise = authTokenService.getTenantId();
            return $q.all([userPromise, tenantPromise]).then(([storeAdmin, tenantID]) => {
                let user = { firstName: storeAdmin.firstName, lastName: storeAdmin.lastName };
                return creditCardService.createStripeCcToken(card, user, billingAddress).then((cardResponse) => {
                    if (cardResponse.card && cardResponse.card.funding === 'prepaid') {
                        trackEvent(
                            'prepaidCard',
                            {
                                type: 'change_attempt',
                                tenantID
                            }
                        );
                        throw new Error(`Prepaid cards are not currently accepted.
                            Please provide a credit or debit card, or contact us for help.`);
                    }
                    const stripeCcToken = get(cardResponse, 'id', null);
                    return paymentMethodService.updatePaymentMethod(stripeCcToken);
                }, (error) => {
                    return $q.reject({
                        description: 'Stripe Token Error',
                        data: error
                    });
                });
            });
        }

        return {
            changePaymentMethod
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/updatePayment/updatePayment.service.js